import { createAsyncThunk } from '@reduxjs/toolkit';
import { CakeBox } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchCakeBox, FindCakeBox, GetCakeBox } from './interface';

export const findCakeBox = createAsyncThunk(
  'cakeBox/findCakeBox',
  async (values: FindCakeBox, { rejectWithValue }) => {
    try {
      const response = await CakeBox.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createCakeBox = createAsyncThunk(
  'cakeBox/createCakeBox',
  async (values: CreatePatchCakeBox, { rejectWithValue }) => {
    try {
      const response = await CakeBox.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchCakeBox = createAsyncThunk(
  'cakeBox/patchCakeBox',
  async ({ id, ...values }: CreatePatchCakeBox, { rejectWithValue }) => {
    try {
      const response = await CakeBox.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getCakeBox = createAsyncThunk(
  'cakeBox/getCakeBox',
  async ({ id }: GetCakeBox, { rejectWithValue }) => {
    try {
      const response = await CakeBox.get(id);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
